import Phaser from 'phaser'

// 물방울이 터지는 듯한 파티클 효과. scale로 크기/양을 키운다.
export class ShatterEmitter {
  constructor(private scene: Phaser.Scene) {}

  burst(x: number, y: number, color = 0xeaf6ff, scale = 1) {
    const count = Math.round(22 * scale)
    for (let i = 0; i < count; i++) {
      // 둥근 물방울(원형). 일부는 더 크게.
      const r = (7 + Math.random() * 13) * scale
      const drop = this.scene.add.circle(x, y, r, color, 0.9).setDepth(20)
      drop.setStrokeStyle(Math.max(1, 2 * scale), 0xffffff, 0.5)
      const ang = Math.random() * Math.PI * 2
      const spd = (130 + Math.random() * 240) * scale
      this.scene.tweens.add({
        targets: drop,
        x: x + Math.cos(ang) * spd,
        y: y + Math.sin(ang) * spd + 90 * scale, // 중력으로 살짝 아래로
        alpha: 0,
        scale: 0.25,
        duration: 600 + Math.random() * 350,
        ease: 'Cubic.easeOut',
        onComplete: () => drop.destroy(),
      })
    }
    // 중심에서 퍼지는 물결 링(스플래시 느낌)
    const ring = this.scene.add
      .circle(x, y, 10 * scale, color, 0)
      .setStrokeStyle(5 * scale, 0xffffff, 0.85)
      .setDepth(20)
    this.scene.tweens.add({
      targets: ring,
      scale: 3.4 * scale,
      alpha: 0,
      duration: 420,
      ease: 'Cubic.easeOut',
      onComplete: () => ring.destroy(),
    })
    // 가운데 밝은 플래시
    const flash = this.scene.add.circle(x, y, 24 * scale, 0xffffff, 0.7).setDepth(20)
    this.scene.tweens.add({
      targets: flash,
      scale: 1.8,
      alpha: 0,
      duration: 260,
      ease: 'Quad.easeOut',
      onComplete: () => flash.destroy(),
    })
  }
}
